import React from "react";
import Dummy from "./components/Login-Dummy";
import './css/login.css';

function Login(){
    return(
        <>
        <div className="container">
            <div className="row">
                <Dummy />
            </div>
        </div>
        </>
    )
}

export default Login;
